import script from "./CommentTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentTextarea.vue?vue&type=script&setup=true&lang=js"

import "./CommentTextarea.vue?vue&type=style&index=0&id=6210f504&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6210f504"]])

export default __exports__